module.exports = __webpack_public_path__ + "img/t0-i1.09184fec.jpg";